import React, { useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import SearchInput from '../../common/SearchInput/SearchInput';

const UserFilters = ({ onChange }) => {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [verified, setVerified] = useState('');

  const emitChange = (next) => {
    onChange?.(next);
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    emitChange({
      search: value,
      status,
      verified,
    });
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);
    emitChange({
      search,
      status: value,
      verified,
    });
  };

  const handleVerifiedChange = (e) => {
    const value = e.target.value;
    setVerified(value);
    emitChange({
      search,
      status,
      verified: value,
    });
  };

  return (
    <Form>
      <Row className="g-2 align-items-end">
        <Col xs={12} md={4}>
          <Form.Label>Поиск (email / имя / логин)</Form.Label>
          <SearchInput value={search} onChange={handleSearchChange} placeholder="Введите строку..." />
        </Col>
        <Col xs={6} md={4}>
          <Form.Label>Статус</Form.Label>
          <Form.Select value={status} onChange={handleStatusChange}>
            <option value="">Все</option>
            <option value="active">Активен</option>
            <option value="creating">Создан</option>
            <option value="registration">Регистрация</option>
            <option value="blocked">Заблокирован</option>
            <option value="deleted">Удалён</option>
          </Form.Select>
        </Col>
        <Col xs={6} md={4}>
          <Form.Label>Верификация</Form.Label>
          <Form.Select value={verified} onChange={handleVerifiedChange}>
            <option value="">Все</option>
            <option value="true">Верифицирован</option>
            <option value="false">Не верифицирован</option>
          </Form.Select>
        </Col>
      </Row>
    </Form>
  );
};

export default UserFilters;

